import React, { useState } from 'react';
import { campanha } from 'models/campanhas';
import PopoverTable from 'components/PopoverTable/popover-table';
import { getCampaignDisplayName } from 'utils/campanha-utils';
import { Line, StatusStyled } from '../style';

interface Props {
  index: number;
  value: campanha;
}

function ItemsColumn({ index, value }: Props) {
  const [openPopover, setOpenPopover] = useState<boolean>(false);

  return (
    <Line key={index}>
      <td>{getCampaignDisplayName(value!['nome-campanha'])}</td>
      <td>{value!['tipo-campanha']}</td>
      <td>{value['grau-ensino']}</td>
      <td>{value!['quantidade-publico']}</td>
      <td>
        <StatusStyled finish={value?.status === 'Finalizada'}>
          {value?.status}
        </StatusStyled>
      </td>
      <td>
        <PopoverTable
          aria-label="Abrir ações da campanha"
          setOpenPopover={setOpenPopover}
          openPopover={openPopover}
          value={value}
        />
      </td>
    </Line>
  );
}

export default ItemsColumn;
